export default __webpack_public_path__ + "static/image3-c5662bfa76afc73a2fbf86e9ce682936.gif";